import * as React from 'react';
import ReactGA from 'react-ga';
import { ImageBackground, StyleSheet, Text, View, Dimensions, FlatList, ActivityIndicator} from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import NewButton from '../components/NewButton';
import CheckBoxItem from '../components/CheckBoxItem';
import DropDownItem from '../components/DropDownItem';
import {SocialActions, SocialActionModal} from '../components/SocialActions';
import ChecklistAction from '../components/ChecklistAction';
import Header from '../components/Header';
import CallAction from '../components/CallAction';
import CallScript from '../components/CallScript';
import AddressForm from '../components/AddressForm';
import Modal from "modal-enhanced-react-native-web";
import ActionTracker from '../utils/ActionTracker';
import {getRepresentatives} from '../utils/RepresentativeLookup';
import {Colors, Fonts} from '../utils/Constants';

const ActionTrack = new ActionTracker();

export default class CheckListScreen extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
      width: Dimensions.get('window').width,
      height: Dimensions.get('window').height,
      selectedFilter: 0,
      showSocialModal: false,
      completedActions: null, //store all completed actions in the state of checklist screen
      campaign: null,
      imageLink: null, //dynamic image link for social media
      representatives: null,
      user_location: null,
      retrievedDynamicContacts: false
    }
    Dimensions.addEventListener("change", this.handler);
    //ensures the campaign slug is valid if not route to home page
    if ("params" in this.props.route) {
      if ("id" in this.props.route.params){
        if(!!this.props.route.params.id) {
          ReactGA.pageview('/' + this.props.route.params.id);
          this.retrieveCampaign(this.props.route.params.id);
        } else {
          this.props.navigation.navigate('Landing');
        }
      } else {
        this.props.navigation.navigate('Landing');
      }
    } else {
      this.props.navigation.navigate('Landing');
    }
  }

  //track height and width changes
  handler = (dims) => {
    this.setState({
      width: dims.window.width,
      height: dims.window.height,
    });
  }
  componentWillUnmount() {
    // Important to stop updating state after unmount
    Dimensions.removeEventListener("change", this.handler);
  }

  retrieveCampaign = (campaign) => {
    fetch('https://fddpufj248.execute-api.us-east-1.amazonaws.com/dev/user/retrieveCampaign/' + campaign)
    .then(response => response.json())
    .then(data => {
      let user_location = localStorage.getItem('user_location'); //retrieve zipcode from localstorage and retrieve reps if applicable
      this.setState({
        campaign: data, //set campaign data to state
        completedActions: ActionTrack.retrieveCampaignData(data.unique_id), //Load data from localstorage + set it to the proper variables to show up
        user_location: user_location
      });
      if (!!user_location) this.retrieveRepresentativeData(user_location);
    })
    .catch((error) => {
      this.props.navigation.navigate('Landing');
      this.setState({campaign: null});
    });
  }

  retrieveRepresentativeData = (address) => {
    ReactGA.event({
      category: 'User',
      action: 'Retrieved Representatives',
    });
    // let isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);
    //only get new reps if zipcode is new and reps don't already exist
    if (address!==this.state.user_location || !!!this.state.representatives) {
      getRepresentatives(address, (rep_data) => {
        console.log("reps retrieved")
        console.log(rep_data)
        if (!!rep_data && !("error" in rep_data)) {
          this.setState({
            user_location: rep_data.user_location,
            representatives: rep_data
          });
          this.createDynamicReps(rep_data);
        }
        localStorage.setItem('user_location', rep_data.user_location);
      });
    }
  }

  createDynamicReps = (rep_data) => {
    // if campaign exists then edit it
    if (!!!this.state.campaign) return;
    //replace dynamic contacts with actual contacts
    var sections_copy = this.state.campaign.sections;
    let contact_section = sections_copy.find(section => section.action_type === 'contact');
    if (!!!contact_section) return;
    //if contact section
    contact_section.content = contact_section.content.filter((item) => !('dynamic' in item))
    for (var idx in contact_section.content){
      if (contact_section.content[idx].type === 'dynamic_contact'){
        let contact_type = contact_section.content[idx].contact_type;
        if (contact_type in rep_data){
          for (var contact_idx in rep_data[contact_type]){
            let contact = rep_data[contact_type][contact_idx];
            let twitter = "channels" in contact.person ? contact.person.channels.find(channel => channel.type === 'Twitter'): "";
            let party = contact.person.party.includes("Republican") ? "R." : contact.person.party.includes("Democratic") ? "D." : "";
            let stateIndex = contact.division_id.indexOf("state:");
            let state = (stateIndex === -1) ? "": contact.division_id.slice(stateIndex + 6, stateIndex+8).toUpperCase();
            let name = contact.person.name + ` (${party} ${state})`;
            let description = contact.person.name === 'VACANT' ? `Your ${contact.office.name} ${!!contact.jurisdiction ? "in " + contact.jurisdiction : ""} is empty` : `Your ${contact.office.name} ${!!contact.jurisdiction ? "in " + contact.jurisdiction : ""}`;
            let modified_contact = {
              description: description,
              email: ('email' in contact_section.content[idx]) ? contact_section.content[idx].email: '',
              name: name,
              phone_number: !!contact.phones ? (contact.phones.length > 0 ? contact.phones[0] : '') : "",
              twitter: !!twitter ? twitter.id : '',
              type: 'contact',
              dynamic: true
            };
            contact_section.content.push(modified_contact);
          }
        }
      }
    }
    const newCampaign = { ...this.state.campaign, sections : sections_copy };
    this.setState({
      campaign: newCampaign,
      retrievedDynamicContacts: true
    });
  }

  changeSelectedFilter = (index) => {
    this.setState({selectedFilter: index});
  }

  //count all actions that have been completed
  countActions = () => {
    let actionTypes = this.state.campaign.sections.map(item => item.action_type)
    let countData = {};
    if (this.state.completedActions == null) {
      for(var i in actionTypes) {
        countData[actionTypes[i]] = 0
     }
     return countData
    } else {
      for (var i in actionTypes) {
        let actionType = actionTypes[i];
        if (actionType in this.state.completedActions) {
          countData[actionType] = Object.keys(this.state.completedActions[actionType]).length;
        } else {
          countData[actionType] = 0;
        }
      }
      return countData;
    }
  }

  //check if an action has been completed
  actionCompleted = (actionName, actionType) => {
    if (this.state.completedActions !== null) {
      if (actionType in this.state.completedActions){
        if (actionName in this.state.completedActions[actionType]){
          return true;
        }
      }
    }
    return false
  }

  //stores the completion of an action to localstorage + db + state variable
  checkOffAction = (action) => {
    ReactGA.event({
      category: 'User',
      action: 'Completed Action',
      label: this.state.campaign.unique_id + "_" + action.type + "_" + action.name
    });
    //stores to local storate + db
    ActionTrack.writeCampaignData(this.state.campaign.unique_id, action);
    //store to state variable
    if (this.state.completedActions == null) {
      let temp_dict = {[action.type]: {[action.name]: 1}};
      this.setState({completedActions: temp_dict});
    }
    else {
      if (!(action.type in this.state.completedActions)){
        const tempCompleted = {...this.state.completedActions, [action.type]: {[action.name]: 1}};
        this.setState({completedActions: tempCompleted});
      } else if (!(action.name in this.state.completedActions[action.type])) {
        const tempActionType = {...this.state.completedActions[action.type], [action.name]: 1};
        const tempCompleted = {...this.state.completedActions, [action.type]: tempActionType};
        this.setState({completedActions: tempCompleted});
      }
    }
  }

  toggleSocialModal = () => {
    let newState = {showSocialModal: !this.state.showSocialModal};
    //force a new image to be generated each time social modal is opened
    if (this.state.showSocialModal) {
      newState.imageLink = null;
    } else {
      ReactGA.modalview('/' + this.props.route.params.id);
      ReactGA.event({
        category: 'User',
        action: 'Opened Share Modal',
        label: this.props.route.params.id
      });
      newState.imageLink = this.generateImageLink();
    }
    this.setState(newState);
  }

  capitalizeFirstLetter = (string) => {
    return string.replace(/\w\S*/g, function(txt){
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  generateImageLink = () => {
    let base_link = 'https://dynamic-image-gen.vercel.app/insta-story?'
    let movement = this.state.campaign.title.toLowerCase().replace(/ /g, '-');
    let slug = this.state.campaign.unique_id.toLowerCase();
    let completed_data = this.countActions();
    var actions = this.state.campaign.sections.reduce((actions, item) => {
      if (completed_data[item.action_type] > 0 && item.action_type !== 'resources') {
        var actionPhrase = item.complete_action_phrase.replace('^%^', completed_data[item.action_type].toString()).toLowerCase().replace(/ /g, '-');
        if (completed_data[item.action_type] === 1 && actionPhrase.slice(-1) === 's') actionPhrase = actionPhrase.slice(0, -1);
        actions.push(actionPhrase);
      }
      return actions;
    }, []).join('--');
    // let actions = this.state.campaign.sections.map(item =>
    //   item.complete_action_phrase.replace('^%^', completed_data[item.action_type].toString())
    //   .toLowerCase().replace(/ /g, '-')
    // ).join('--');
    var link = `${base_link}movement=${movement}&slug=${slug}&actions=${actions}`;
    if ("bgImage" in this.state.campaign){
      link+=`&bgImage=${encodeURIComponent(this.state.campaign.bgImage)}`;
    }
    return link;
  }

  getItem = (item, action_type, styling) => {
    let boxHeight = this.state.width >=1360 ? 105 : 120;
    if (item.type === 'checkbox') {
      return (
        <CheckBoxItem
          item={item}
          key={item.name}
          width = {styling.petitionwidth}
          defaultBgColor={Colors.checkboxBG}
          borderWidth = {1}
          height = {boxHeight}
          actionCompleted = {this.actionCompleted(item.name, action_type)}
          checkOffAction = {() => this.checkOffAction({'name': item.name,'type': action_type})}
        />
      )
    }
    if (item.type === 'dropdown') {
      return (
        <DropDownItem
          title={item.name}
          key={item.name}
          content={item.items}
          actionType={action_type}
          width = {styling.petitionwidth}
          height = {boxHeight}
          checkOffAction = {this.checkOffAction}
          actionCompleted = {this.actionCompleted}
        />
      )
    }
    if (item.type === 'contact') {
      return (
        <CallAction
          title={item.name}
          key={item.name}
          text={item.description}
          number={item.phone_number}
          width = {styling.petitionwidth}
          email = {item.email}
          twitter = {item.twitter}
          screenWidth = {this.state.width}
          script={this.state.campaign.socialMediaScript}
          height = {boxHeight}
          border = {6.49}
          checkOffAction = {() => this.checkOffAction({'name': item.name,'type': action_type})}
          actionCompleted = {this.actionCompleted(item.name, action_type)}
        />
      )
    }
    if (item.type === 'script') {
      return (
        <CallScript
          text={item.text}
          key={item.text}
          width = {styling.petitionwidth}
          screenWidth = {this.state.width}
          height = {55}
          border = {6.49}
        />
      )
    }
    if (item.type === 'address_form') {
      return (
        <AddressForm
          representatives={this.state.representatives}
          location={this.state.user_location}
          key={'address_form'}
          width = {styling.petitionwidth}
          screenWidth = {this.state.width}
          getRepresentatives={this.retrieveRepresentativeData}
        />
      )
    }
    if (item.type === 'description') {
      return (
        <Text key={item.text} style={[styles.text, {width: styling.petitionwidth, paddingBottom: 20}]}>
          {item.text}
        </Text>
      )
    }
    if (item.type === 'dynamic_contact' && !this.state.retrievedDynamicContacts) {
      return (
        <CallAction
          title={"Your " + item.contact_type}
          key={item.contact_type}
          number={''}
          width = {styling.petitionwidth}
          screenWidth = {this.state.width}
          height = {boxHeight}
          border = {6.49}
        />
      )
    }
  }


  render(){
    let widthCutoff = 1360;
    let styling = {};
    if (this.state.width >=widthCutoff){
      styling.width = this.state.width >= 1360 ? 1067 : '75%',
      styling.campaigntitle = 42;
      styling.titlepadding = 40;
      styling.titletext = {color:'white',fontFamily: Fonts.mainFont, fontWeight: '500', fontSize: 18};
      styling.list = {direction: false, width: 170};
      styling.bottomPage = {
        width: styling.width,
        flexDirection: 'row',
        justifyContent: 'center',
        paddingTop: 31,
        paddingBottom: 50
      };
      styling.campaignimage ={
        width: this.state.width >= 1360 ? 1067 : '75%',
        // height: 292,
        // resizeMode: 'center',
        alignContent: 'center',
        overflow: 'hidden'
      }
      styling.align = 'flex-start'
      styling.layout = 'row';
      styling.petitionwidth = 630;
      styling.petitionheight = 104;
    } else {
      styling.width = this.state.width >= 1067 ? 1067 : '100%';
      styling.campaigntitle = this.state.width >=740 ? 42 : 25;
      styling.titletext = {color:'white',fontFamily: Fonts.mainFont, fontWeight: '500', fontSize: this.state.width >=740 ? 18 : 15};
      styling.list = {direction: true, width: '100%'};
      styling.titlepadding = this.state.width >=740 ? 40 : 20;
      styling.bottomPage = {
        width: styling.width,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        paddingTop: 10,
        paddingBottom: 50
      };
      styling.campaignimage ={
        width: styling.width,
        // height: this.state.width >=740 ? 292 : this.state.width * 0.4,
        // resizeMode: 'center',
        alignContent: 'center',
        overflow: 'hidden'
      }
      styling.align = 'flex-start';
      styling.layout = this.state.width >= 960 ? 'row' : 'column';
      styling.petitionwidth = '100%';
    }
    //determine font sizes
    styling.font = this.state.width >= 540 ? {top: 44,mid: 40,low: 20} : {top: 23,mid: 20,low: 15};
    //don't show anything until the campaign is loaded from the db
    if (this.state.campaign === null) return (
      <View style={{alignItems: 'center', justifyContent: 'center', flex: 1}}>
        <ActivityIndicator size="large" color="black" />
        <Text style={{color: 'black',fontSize: 13.44,fontFamily: Fonts.mainFont, marginTop: 10}}>
          Loading...
        </Text>
      </View>
    );

    let completed_data = this.countActions();
    let sectionData = this.state.campaign.sections.map(item => {
      return {
        name: item.name,
        action_type: item.action_type,
        short_phrase_mobile: this.capitalizeFirstLetter(item.short_action_phrase),
        short_phrase_desktop: item.short_action_phrase,
        long_phrase: item.complete_action_phrase,
        number_completed: completed_data[item.action_type].toString()
      }
    });
    return (
      <View style={styles.container}>
        {/* Share Progress Modal */}
        <Modal isVisible={this.state.showSocialModal} style={{alignItems: 'center'}}>
         <SocialActionModal width={this.state.width < 500 ? '90%' : 500}
          parentWidth={this.state.width} close={this.toggleSocialModal}
          imageLink={this.state.imageLink} slug={this.state.campaign.unique_id}
          name={this.state.campaign.title}
          />
        </Modal>
        <ScrollView contentContainerStyle={styles.contentContainer} bounces={true}>
          {/* Image Header with Title and Description */}
          <ImageBackground
            style={styling.campaignimage}
            imageStyle={{ width: '100%', overflow: 'hidden'}}
            source={this.state.campaign.header_image}
          >
            <View style={{paddingTop: 10, paddingLeft: styling.titlepadding, paddingBottom: styling.titlepadding, paddingRight: styling.titlepadding, flex: 1, width: '100%', backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <Header navigation={this.props.navigation} width={'100%'} screenWidth={this.state.width}/>
              <View style={{paddingTop: 15, flex: 1, justifyContent: 'space-evenly'}}>
                <Text style={{fontStyle: 'italic', color:'white',fontFamily: Fonts.mainFont, fontWeight: '900', fontSize: styling.campaigntitle}}>
                  {this.state.campaign.title.toUpperCase()}
                </Text>
                <Text style={styling.titletext}>
                  {this.state.campaign.description}
                </Text>
              </View>
            </View>
          </ImageBackground>
          <View style={styling.bottomPage}>
            {/* Content Section Filters */}
            <View style={{width: styling.list.width, marginBottom: 10, marginTop: 10}}>
              <FlatList
                data={sectionData}
                horizontal = {styling.list.direction}
                extraData={this.state.selectedFilter}
                style={{width: '100%'}}
                keyExtractor={item => item.name}
                showsHorizontalScrollIndicator={false}
                renderItem={({ item, index }) => (
                  <ChecklistAction
                    text={item.name}
                    width = {150}
                    height = {30.52}
                    border = {71.73}
                    action = {this.changeSelectedFilter}
                    selectedFilter = {this.state.selectedFilter}
                    index = {index}
                  />
                )}
              />
            </View>
            <View style={{flexDirection: styling.layout, alignItems: styling.align, justifyContent: 'center'}}>
              {/* Checkbox Items */}
              <FlatList
                data={this.state.campaign.sections[this.state.selectedFilter].content}
                style={{padding: 20, marginTop: -20, width: '100%'}}
                keyExtractor={(item, index) => {
                  if ('name' in item) return item.name;
                  if ('text' in item) return item.text;
                  if ('contact_type' in item) return item.contact_type+item.type;
                  return index.toString();
                }}
                renderItem={({item}) => this.getItem(item, sectionData[this.state.selectedFilter].action_type, styling)}
              />
              {/* Desktop Screen Action Counter */}
              {this.state.width >=960 &&
                <SocialActions
                  shareProgress={this.toggleSocialModal}
                  items={sectionData}
                />
              }
            </View>
          </View>
        </ScrollView>
        {/* Mobile Action Counter */}
        {this.state.width < 960 &&
        <View style={styles.mobileActionCounter}>
          {sectionData.map((item) => (
                <Text key={item.action_type} style={{color: 'white', marginRight: '5%', textAlign: 'center', fontSize: 12}}>
                  <Text style={{fontWeight: 'bold'}}>
                    {item.number_completed}
                  </Text>
                  {"\n" + item.short_phrase_mobile}
                </Text>
            ))}
          <NewButton textColor='white' height={40} width={70} color={Colors.cobalt} fontWeight='500'
            text='Share Impact' fontSize={12} action={this.toggleSocialModal}
            />
        </View>
        }
      </View>
    );
  }
}

CheckListScreen.navigationOptions = {
  header: null,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white'
  },
  contentContainer: {
    alignItems: 'center',
    //flexGrow: 1,
    flex: 1,
    backgroundColor: '#FFFFFF'
  },
  tabBar: {
    alignItems: 'center',
    justifyContent: 'space-around',
    //flexGrow: 1,
    //flex: 1,
    backgroundColor: '#FFFFFF',
    height: 75
  },
  welcomeContainer: {
    alignItems: 'center',
    flex: 1,
    marginTop: 10,
    marginBottom: 20,
  },
  socialMedia: {
    width: 194,
    height: 110,
    padding: 15,
    alignItems: 'center',
    borderRadius: 6.49,
    borderColor: 'black',
    borderWidth: 1,
    justifyContent: 'center',
  },
  text: {
    color: 'black',
    fontSize: 18,
    fontFamily: Fonts.mainFont
  },
  mobileActionCounter: {
    height: 60,
    backgroundColor: '#202020',
    opacity: 0.9,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10
  }
});